import { memo } from 'react'
import i18n from '../../../utilities/i18n'
import Button from '../../Buttons/Button'
import { refreshStyles, reload, rootStyles, verificationStyles } from './shared'

const SignupVerified = memo(() => (
    <div css={rootStyles}>
        <h4 className="typography gutter-bottom centered">
            {i18n.t('signup.thankYouForVerifying')}
        </h4>
        <div className="centered" css={verificationStyles}>
            {i18n.t('signup.refreshToContinue')}
        </div>
        <Button onClick={reload} css={refreshStyles} size="medium">
            {i18n.t('signup.refresh')}
        </Button>
    </div>
))

export default SignupVerified
